// Material
import { Skeleton, TypographyProps } from '@mui/material'
// Logic
import { useHall } from '$logic/hall/react-hook'
// Localization
import { useSubscription } from '$logic/subscription/react-hook'
import { toLocale } from '$func/text'
import { t } from '$i18n'
import { WithQueryTitleBase } from '../with-query-title-base'

interface Props extends TypographyProps {
  hallId: string
  query: string
}

export function WithQueryHallListItemStatus({
  hallId,
  query,
  ...other
}: Props) {
  const { entity: hall, loading } = useHall(hallId)
  const { entity: subscription, err } = useSubscription(hallId)

  if (err) return null
  if (loading || !hall) return <Skeleton variant="text" />

  const hallIdentifier = hall.identifier ? `${hall.identifier}@` : ''

  const title = hall.public
    ? subscription
      ? hallIdentifier
      : `${toLocale(hall.membersCount)} ${t('profile.hall.member')}${
          hallIdentifier ? ` - ${hallIdentifier}` : ''
        }`
    : t('profile.hall.options.type.private')

  return (
    <WithQueryTitleBase
      query={query}
      title={title}
      variant="caption1"
      direction="rtl"
      {...other}
    />
  )
}
